// import moment from "moment";
// import { amountFormatter, dateFilterComparator } from "../../utils/utils";

import moment from "moment";

export const columnDefs = [
  {
    headerName: "Employee Id",
    field: "userId",
    locked: true,
    hide: false,
    width: 120,
  },
  {
    headerName: "First Name",
    field: "firstName",
    locked: true,
    hide: false,
    width: 120,
  },
  {
    headerName: "Last Name",
    field: "lastName",
    locked: true,
    hide: false,
    width: 120,
  },
  {
    headerName: "Email",
    field: "email",
    locked: true,
    hide: false,
    width: 160,
    // filter: "agDateColumnFilter",
  },
  {
    headerName: "Phone",
    field: "phoneNumber",
    locked: true,
    hide: false,
    width: 100,
  },
  {
    headerName: "Role",
    field: "roles",
    locked: true,
    hide: false,
    width: 100,
  },
  {
    headerName: "Status",
    field: "status",
    width: 130,
  },
  {
    headerName: "Created Date",
    field: "createdTime",
    locked: true,
    hide: false,
    width: 180,
  },
  {
    headerName: "Updated Date",
    field: "updatedTime",
    locked: true,
    hide: false,
    width: 180,
  },
  {
    headerName: "Updated By",
    field: "nameOfUpdatedBy",
    width: 120,
    hide: false,
  },
  {
    headerName: "Updated By User Code",
    field: "updatedBy",
    hide: false,
    width: 150,
  },
  {
    headerName: "Location",
    field: "branch",
    width: 120,
  },
  {
    headerName: "Last Login Date",
    field: "lastLoginTime",
    hide: false,
    width: 180,
  },
  {
    headerName: "Deactivate Date",
    field: "ttl",
    width: 175,
  },
];

export const transformPayload = (data) => {
  return {
    company: undefined,
    userId: data.userId,
    createdBy: undefined,
    deleted: false,
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    password: data.password,
    roles: [data.role],
    passPhrase: data.passPhrase,
    phoneNumber: data.phoneNumber,
    branch: data.branch || [],
    ttl: data.ttl || null,
    resetPasswordInDays: data.resetPasswordInDays || 60,
    status: data?.status?.id || statusOptions[0].id,
    src: "CAC",
    address: data.address || "",
    designation: data.designation || "",
    joiningDate: data.joiningDate || null,
  };
};

export const columnDefsFunctions = {
  roles: {
    valueGetter: (params) =>
      params.data.roles?.length ? params.data.roles[0]?.role : null,
  },
  createdTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  updatedTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  ttl: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
  },
  lastLoginTime: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
  },
};

export const userLogsColDefs = [
  {
    headerName: "Employee Id",
    field: "userId",
    maxWidth: 200,
  },
  {
    headerName: "Updated Time",
    field: "created_at",
    maxWidth: 200,
    valueGetter: (params) => {
      return moment(`${params.data.created_at}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  {
    headerName: "Log Details",
    field: "message",
  },
];
export const statusOptions = [
  { id: "ACTIVE", label: "Active", disabled: false },
  { id: "DISABLED", label: "Disabled", disabled: false },
  { id: "INACTIVE", label: "Inactive", disabled: true },
  { id: "USER_EXPIRED", label: "User Expired", disabled: true },
  { id: "PASSWORD_EXPIRED", label: "Password Expired", disabled: true },
];
